import React from 'react'
import IconButton, {IconButtonProps} from '@mui/material/IconButton'
import styled from 'styled-components'
import icon_buttonStyles from './icon_button.styles'

import {AhdIconTypes} from '../../../assets/icons/iconslist'
import SvgIconAtom from '../../to_content/svg_icon/svg_icon.atom'

interface ApIconButtonProps extends IconButtonProps, AhdIconTypes {
  width?: string
  height?: string
}

const apAtomName = {ap_atom_name: 'iconButtonAtom'}

const IconButtonAtom = styled((props: ApIconButtonProps) => (
  <IconButton {...apAtomName} {...props}>
    <SvgIconAtom
      ap_type={props.ap_type}
      ap_color={props.ap_color}
      width={props.width}
      height={props.height}
    />
  </IconButton>
))`
  ${icon_buttonStyles}
`

export default IconButtonAtom
